import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { Index } from "@/components/site/HomePage";

import { pageSchemas } from "@/lib/seo/page-schema";
const DESC =
  "Perceptica е платформата за медиен мониторинг и медийно разузнаване в Югоизточна Европа.";

export const Route = createFileRoute("/bg/")({
  head: () => ({
    meta: [
      { title: "Медиен мониторинг и медиен анализ в България | Perceptica" },
      { name: "description", content: DESC },
      { property: "og:title", content: "Медиен мониторинг и медиен анализ в България | Perceptica" },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },

      ...ogImageMeta("bg", "/", "Perceptica медийно разузнаване"),
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Медиен мониторинг и медиен анализ в България | Perceptica" },
      { name: "twitter:description", content: DESC },
      { property: "og:url", content: "https://perceptica.com/bg" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/", collection: { name: "Perceptica", description: "Media monitoring & intelligence for SEE" } }),
  }),
  component: Index,
});
